


import { Component, Vue, Watch } from 'vue-property-decorator';
import Searchbox from './Searchbox.vue';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Loader from './Loader.vue';
import Broadcast from './Broadcast.vue';
import Joblisting from './Joblisting.vue';
import JobAlertUI from './JobAlertUI.vue';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import router from '../../../router';
import moment from 'moment';
import { SurveyListRequest } from './../../../models/candidatesurvey/candidatesurveyresponse';
import _ from 'lodash';
import {
  CANDIDATE_PORTAL_SURVEY_STATUS_NEW,
  CANDIDATE_PORTAL_SURVEY_STATUS_SUBMITTED,
  CANDIDATE_PORTAL_SURVEY_STATUS_RESPONSE_PENDING,
  CANDIDATE_PORTAL_SURVEY_TODAY_TEXT,
  CANDIDATE_PORTAL_SURVEY_STATUS_CODE_SUBMITTED,
  CANDIDATE_PORTAL_SURVEY_STATUS_CODE_RESPONSE_PENDING,
  CANDIDATE_PORTAL_SURVEY_STATUS_CODE_NEW,
  SURVEY_DETAILS_ERROR_MESSAGE,
} from './../SurveyConstants';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'SurveyLanding',
  components: {},
})
export default class SurveyLanding extends Vue {
  public noSurveyAssigned: boolean = false;
  public surveyHomePageData: any[] = [];
  public isDataArrived: boolean = false;
  public isRotated: boolean = false;
  public isLoading: boolean = false;
  public isFullDataArrived: boolean = false;
  public $wlToastr: any;
  currentSurveys: any[] = [];
  surveys = [];
  public reqObj: SurveyListRequest = {
    sessionToken: '1223',
    resultSize: 10,
    resultPage: 1,
  };

  goToSurveyPage(survey) {
    this.$router.push({
      name: 'surveyPage',
      //params: { userId : "1", surveyId :"3"}
    });
  }

  get userId() {
    return vxm.users.myUserProfile.userId;
  }

  formatDateToDayDateMonthYear(timestamp: any) {
    if (Number.isInteger(timestamp) && timestamp) {
      return moment(timestamp).format('ddd, Do MMM, YYYY');
    } else return timestamp;
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  handleScroll(event) {
    if (!this.isFullDataArrived) {
      let listElm: any = document.querySelector('.survey-landing-page');
      if (listElm['scrollTop'] + listElm.clientHeight >= listElm.scrollHeight) {
        if (this.isRotated) {
          this.fecthSurveyListData();
        }
      }
    }
  }

  mounted() {
    vxm.utility.setSpinnerStatus(true);
    this.fecthSurveyListData();
  }

  getSurveyStatus(statusCode) {
    if (statusCode === CANDIDATE_PORTAL_SURVEY_STATUS_CODE_NEW) {
      return CANDIDATE_PORTAL_SURVEY_STATUS_NEW;
    } else if (
      statusCode === CANDIDATE_PORTAL_SURVEY_STATUS_CODE_RESPONSE_PENDING
    ) {
      return CANDIDATE_PORTAL_SURVEY_STATUS_RESPONSE_PENDING;
    } else if (statusCode === CANDIDATE_PORTAL_SURVEY_STATUS_CODE_SUBMITTED) {
      return 'Responded';
    } else {
      return statusCode;
    }
  }

  fecthSurveyListData() {
    this.isRotated = false;
    this.reqObj.resultPage = this.currentSurveys
      ? this.currentSurveys.length / this.reqObj.resultSize + 1
      : 1;
    let respPromise = vxm.users.getSurveyList(this.reqObj);
    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then(
      (response) => {
        if (response) {
          if (response[0]['surveys'] && response[0]['surveys'].length > 0) {
            this.noSurveyAssigned = false;
            this.currentSurveys = this.currentSurveys.concat(
              response[0]['surveys'],
            );
            if (this.currentSurveys.length === response[0].resultCount) {
              this.isFullDataArrived = true;
            }
            this.surveyHomePageData = this.groupSurveysByDate(
              this.currentSurveys,
            );
            vxm.utility.setSpinnerStatus(false);
          } else {
            this.noSurveyAssigned = true;
          }
          this.isDataArrived = true;
          this.isRotated = true;
        }
        this.$modal.hide('survey-spinner');
      },
      (err) => {
        this.$wlToastr(
          'error',
          SURVEY_DETAILS_ERROR_MESSAGE,
          this.$t('candidate-survey-text'),
        );
      },
    );
  }

  groupSurveysByDate(surveys: any) {
    if (!surveys || surveys.length === 0) {
      return;
    }
    let surveyData = surveys.map((survey) => {
      if (moment(survey.surveySentDate).isSame(moment(), 'day')) {
        survey.surveySentDate = CANDIDATE_PORTAL_SURVEY_TODAY_TEXT;
      } else {
        survey.surveySentDate = this.formatDateToDayDateMonthYear(
          survey.surveySentDate,
        );
      }
      return survey;
    });
    let map = new Map();
    surveyData.forEach((survey) => {
      if (map.get(survey.surveySentDate)) {
        let t = map.get(survey.surveySentDate);
        t.push(survey);
        map.set(survey.surveySentDate, t);
      } else {
        let t = [survey];
        map.set(survey.surveySentDate, t);
      }
    });
    let outputSurveyArray: any = [];
    for (let [key, value] of map.entries()) {
      outputSurveyArray.push({ date: key, surveys: value });
    }
    outputSurveyArray.sort(this.sortByProperty('date'));
    return outputSurveyArray;
  }

  sortByProperty(property) {
    return function(a, b) {
      if (property === 'date') {
        if (moment(a[property]) > moment(b[property])) return 1;
        else if (moment(a[property]) < moment(b[property])) return -1;
        return 0;
      } else {
        if (a[property] > b[property]) return 1;
        else if (a[property] < b[property]) return -1;
        return 0;
      }
    };
  }
}
